/* eslint-disable lingui/no-unlocalized-strings */
import { useAuthedUserContext } from '@/clients/shared-hooks/use-authed-user';
import { useEffect } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { BasicLoading } from '../components/BasicLoading';
import { Header } from '../components/Header';
import { SessionContextProvider } from './hooks/use-session-context';
import styles from './platform-styles.module.css';

export function PlatformTemplate() {
  const navigate = useNavigate();
  const { customer } = useAuthedUserContext();
  useEffect(() => {
    if (!customer.enablePlatformBeta) {
      navigate('/');
    }
  }, [customer.enablePlatformBeta, navigate]);

  if (!customer.enablePlatformBeta) {
    return <BasicLoading />;
  }

  return (
    <SessionContextProvider>
      <div className={styles.screen}>
        <Header>
          <div className="flex-1 h-full flex justify-center items-center gap-6 px-3">
            <Link to="/platform" className="hover:underline text-primary">
              Dashboard
            </Link>
            <Link to="/platform/use-cases" className="hover:underline text-primary">
              Use Cases
            </Link>
          </div>
        </Header>
        <main>
          <div className="pt-20">
            <Outlet />
          </div>
        </main>
      </div>
    </SessionContextProvider>
  );
}
